import { onViewAllMenuClicked, onSearchTextChanged } from '../actions/internalActions';
import { getStore } from '../store/store';
import { mutator } from 'satcheljs';

// show all folders of present moveTo mailbox context
mutator(onViewAllMenuClicked, () => {
    getStore().shouldShowAllFolders = true;
});

mutator(onSearchTextChanged, actionMessage => {
    const moveToStore = getStore();
    // Only if we are in Primary mbx mode we will reset shouldShowAllFolders
    if (moveToStore.moveToMailboxContext === 'primary') {
        // if search text is not empty then all folders should be shown, else default view will be shown
        moveToStore.shouldShowAllFolders = actionMessage.searchText.length > 0;
    }
});
